import { IconDropdownMenu } from '@strata/react-dropdown-menu';
import PropTypes from 'prop-types';

export const OrtfOutboundFileRowMenu = ({ reviewed, onToggleReviewed, onDownload }) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={(e) => e?.stopPropagation()}>
        <IconDropdownMenu
            title="Outbound file actions"
            className="sds_referral-grid__row-menu-button"
            menuItems={[
                {
                    text: 'Download',
                    onItemClick: onDownload,
                },
                {
                    text: reviewed ? 'Set as not reviewed' : 'Set as reviewed',
                    onItemClick: onToggleReviewed,
                },
            ]}
        />
    </div>
);

OrtfOutboundFileRowMenu.propTypes = {
    reviewed: PropTypes.bool.isRequired,
    onToggleReviewed: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
};
